@if (params && params.getMessage) {
  <p>{{ params.getMessage() }}</p>
}
